import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import { useFeatures } from '@/composables/useFeatures';
import { useAiMetadataStore } from '@/modules/viewer/store/useAiMetadataStore';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { ItemType, useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { TRANSLATION_FEATURE_FLAG, useTranslationStore } from '@/modules/viewer/store/useTranslationStore';

export const useTranslationAvailability = () => {
  const { getItemFeature } = useFeatures();
  const { type: itemType, description } = storeToRefs(useViewerItemStore());
  const { availableLanguages } = storeToRefs(useTranslationStore());
  const { hasChapters } = storeToRefs(useAiMetadataStore());
  const { isTranscriptionMissingContent } = storeToRefs(useTranscriptionStore());

  const translationEnabled = getItemFeature(TRANSLATION_FEATURE_FLAG, false);

  // Mirrors SegmentTranslator.translatable?: the title alone is not content to
  // translate, a typed description on a silent video is.
  const hasTranslatableContent = computed(() => !!description.value || hasChapters.value || !isTranscriptionMissingContent.value);

  const isTranslationAvailable = computed(
    () => translationEnabled.value && itemType.value === ItemType.VIDEO && availableLanguages.value.length > 0 && hasTranslatableContent.value
  );

  return { isTranslationAvailable };
};
